import { Component, Input } from '@angular/core'
import { StepperService } from '@app/services/stepper.service'
import { Observable } from 'rxjs'

@Component({
	selector: 'mv-step',
	templateUrl: './step.component.html',
	styleUrls: ['./step.component.scss'],
})
export class StepComponent {
	@Input() step!: number
	@Input() ariaLabel!: string
	public readonly currentStep$!: Observable<number>

	constructor (private readonly stepperService: StepperService) {
		this.currentStep$ = this.stepperService.currentStep$
	}

}
